export default "__VITE_ASSET__CkJHdjpM__"